$easyreels_user_recordings $mol_view
	used_bytes 0
	limit_bytes 0
	sub /
		<= List $mol_list
			Empty <= Empty $mol_paragraph
				title @ \Nothing here yet
			rows <= rows /$mol_view
	Pending $mol_paragraph
		title @ \Loading the recordings…
	Item* $easyreels_user_recording
		recording <= row* null
